<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM>
            {{r.email}}
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            {{r.type == 1 ? 'Language' : r.type == 2 ? 'Seminars' : r.type == 3 ? 'Appointments' : 'U/A'}}
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PHONE>
            Active
            <v-avatar
              size="10"
              class="mx-1"
              :color="`${r.active ? 'success' : 'error'}`"
            >
            </v-avatar>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1  font-weight-bold`" DATETIME>
            {{r.busy ? 'Busy' : 'Free'}}
            <v-avatar
              size="10"
              class="mx-1"
              :color="`${r.busy ? 'error' : 'success'}`"
            >
            </v-avatar>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`" EDITBUTTON>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  :disabled="r.lock" v-if="!match"
                  x-small @click.stop="reset(r)">
                  <v-icon left size="12">lock_reset</v-icon>
                  reset
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                reset
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'match'],
  methods:{
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    getColor(status) {
      if(status == 'new') {
        return 'success'
      } else
      if(status == 'to_create') {
        return '#9c27b0'
      } else
      if(status == 'confirmed') {
        return 'primary'
      } else
      if(status == 'interview') {
        return '#8bc34a'
      } else
      if(status == 'accepted') {
        return '#00bcd4'
      } else
      if(status == 'need_follow_up' || status == 'out_of_reach') {
        return "#FFC107"
      } else {
        return 'error'
      }
    },
    edit(r) {
      this.$emit('editLead', r)
    },
    reset(r) {
      this.$emit('reset', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>